export const contactsData = {
    email: 'rabsamuel@gmail.com',
    phone: '+91 7507086990',
    address: 'Rewari, Harayan, India- 123303 ',

    sheetAPI: ''
}